export default {
  /**
   * Determine if token has reset password link
   * @param {String} loginToken token from login API response
   */
  isTokenExpired(loginToken) {
    return loginToken && loginToken.includes('reset-password');
  },
};
